<template>
  <div v-if="store.banners.length" class="shrink-0 lg:pl-56" role="region" aria-label="Avisos">
    <div
      v-for="n in store.banners"
      :key="n.id"
      class="flex items-start gap-3 border-b px-4 py-2.5 text-sm"
      :class="tone(n).box"
      role="status"
    >
      <ExclamationTriangleIcon class="mt-0.5 h-5 w-5 shrink-0" :class="tone(n).icon" aria-hidden="true" />
      <div class="min-w-0 flex-1">
        <p class="font-semibold">{{ n.title }}</p>
        <!-- Texto ja sanitizado pelo servidor (so formatacao e links) -->
        <div class="notice-body notice-banner-body" v-html="n.body_html"></div>
      </div>
      <button
        v-if="!store.readOnly"
        type="button"
        class="shrink-0 rounded-md border border-current px-3 py-1 text-xs font-medium hover:bg-white/60 disabled:opacity-60"
        :disabled="busy[n.id]"
        @click="dismiss(n)"
      >
        {{ n.ack_label || 'Entendi' }}
      </button>
    </div>
  </div>
</template>

<script>
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline';
import { useNoticeStore } from '_app/stores/noticeStore';

const TONES = {
  info: { box: 'bg-blue-50 text-blue-900 border-blue-200', icon: 'text-blue-600' },
  warning: { box: 'bg-amber-50 text-amber-900 border-amber-200', icon: 'text-amber-600' },
  critical: { box: 'bg-red-50 text-red-900 border-red-200', icon: 'text-red-600' },
};

// Faixa fixa no topo do app para avisos automaticos (ex.: WhatsApp desconectado). Nao bloqueia nada:
// o lojista pode dispensar ("Entendi"); a exibicao e a leitura ficam registradas no servidor.
// O aviso some sozinho quando a causa acaba (o servidor manda notice:cancelled).
export default {
  name: 'NoticeBanner',

  components: { ExclamationTriangleIcon },

  data() {
    return { store: useNoticeStore(), busy: {} };
  },

  watch: {
    // Registra a exibicao de cada faixa uma vez
    'store.banners': {
      handler(list) { list.forEach((n) => this.store.markShown(n.id)); },
      immediate: true,
    },
  },

  methods: {
    tone(n) {
      return TONES[n.severity] || TONES.warning;
    },

    async dismiss(n) {
      this.busy = { ...this.busy, [n.id]: true };
      await this.store.ack(n.id);
      this.busy = { ...this.busy, [n.id]: false };
    },
  },
};
</script>

<style>
.notice-banner-body p { margin: 0 0 0.25em; min-height: 0; font-size: 0.8125rem; line-height: 1.4; }
.notice-banner-body a { font-weight: 600; }
</style>
